// extracted by mini-css-extract-plugin
export var assigneeBadge = "_o3-0";
export var assigneeDetails = "_o3-1";
export var assigneeInfo = "_o3-2";
export var dropdownContainer = "_o3-4";
export var dropdownImage = "_o3-5";
export var editAssigneeInfo = "_o3-3";
export var editAssigneeModalContainer = "_o3-6";
export var hidden = "_o3-8";
export var input = "_o3-7";